import { render, staticRenderFns } from "./DefaultEventDetail.vue?vue&type=template&id=11fcc177"
import script from "./DefaultEventDetail.vue?vue&type=script&lang=js"
export * from "./DefaultEventDetail.vue?vue&type=script&lang=js"
import style0 from "./DefaultEventDetail.vue?vue&type=style&index=0&id=11fcc177&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports